<template>
  <!-- 企业介绍-->
  <section class="feature-area section-padding2">
    <div class="container">

      <div class="row flexJCenter">
        <div class="col-lg-6">
          <div class="row">
            <div class="col-lg-12">
              <div class="">
                <h3 class='title borderABC'>{{introduceInfo[0].title}}</h3>
                <p class='titleShadow'>{{introduceInfo[0].subTitle}}</p>
              </div>
            </div>
          </div>
          <div class="mb-5">
            <p v-html='introduceInfo[0].content'></p>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="mb-3">
            <img style='width: 100%;' :src="url" alt="古都旅游">
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
  export default{
    props:{
    	type: null,
      url:null,
    },
    data(){
      return{
      introduceInfo:[]
      }
    },
    mounted() {
      this.$http({
        method:'get',
        url:'http://123.57.1.182/website/api/website/article/list?type='+this.type,
        data:{}
      }).then((res) => {
        console.log(res)
        if(res.data.code == 200){
          this.introduceInfo = res.data.data
        }
      })
    },

  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// introduce.vue?48507cea